/**
 * @deprecated
 */
export default function (context) {
    $('.input-group-dateselector .time-selector', context).on('change', function () {
        updateHidden($(this).parent());
    })

    $('.input-group-dateselector .date-selector', context).on('change', function () {
        if (!$(this).is('day')) {
            adjustDays($(this).parent());
        }
        updateHidden($(this).parent());
    })

    $('input-group-dateselector .clear-date', context).on('click', function (){
        $(this).parent().find('.date-selector').val('').trigger('change');
    });

    const updateHidden = function (wrapper) {
        let val = '';
        if (wrapper.data('preselect') && wrapper.find('.time').val()) {
            val = wrapper.data('preselect') + ' ' + wrapper.find('.time').val();
        } else {
            let t = '00:00';
            let y = wrapper.find('.year').val()
            let m = wrapper.find('.month').val();
            let d = wrapper.find('.day').val();
            if (wrapper.find('.time').length && wrapper.find('.time').val()) {
                t = wrapper.find('.time').val();
            }
            if (y && m && d) {
                // save with or without time
                val = `${d}/${m}/${y} ${t}`;
            } else {
                val = '';
            }
        }
        wrapper.find('input[type="hidden"].date-formatted').val(val).trigger('change');
    }

    const hideDays = {
        "02":["29","30","31"],
        "04": ["31"],
        "06": ["31"],
        "09": ["31"],
        "11": ["31"],
    };
    const adjustDays = function (wrapper) {
        let y = wrapper.find('.year').val()
        let m = wrapper.find('.month').val();
        let d = wrapper.find('.day');
        let hide = hideDays[m] || null;
        wrapper.find('.day option').removeClass('hidden');
        if (hide) {
            hide.forEach(function (hide_d) {
                if (d.val() === hide_d) {
                    d.val('');
                }
                wrapper.find(`.day option[value="${hide_d}"]`).addClass('hidden');
            })
            if ((m === "2") &&  (y % 4 === 0)) {
                wrapper.find('.day option[value="29"]').removeClass('hidden');
            }
        }
    }

    // Workaround to update altered default values.
    $('.input-group-dateselector .date-selector', context).trigger('change');
}
